import { ApiClientError, ApiEnvelope } from '../../models/api/api-envelope';
import { AuthenticatedSession, AuthenticatedUser } from '../../models/api/auth';

export type LoginResponse = ApiEnvelope<AuthenticatedUser[]>;

export function mapLoginResponse(response: LoginResponse): AuthenticatedSession {
  if (!response || Number(response.code) !== 0) {
    throw new ApiClientError('api', 'La autenticación fue rechazada.');
  }
  if (!Array.isArray(response.data) || response.data.length === 0) {
    throw new ApiClientError('invalid-response', 'La respuesta de autenticación no es válida.');
  }
  const user = response.data[0];
  if (!user || typeof user.apikey !== 'string' || !user.apikey || typeof user.nombre !== 'string') {
    throw new ApiClientError('invalid-response', 'La respuesta de autenticación no es válida.');
  }
  return { apiKey: user.apikey, userName: user.nombre };
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth-mapper.ts